/* eslint-disable */
import moment from "moment-timezone";

export default {
  methods: {
    formatTimestamp: (t, format="MMM Do") => {
      if (!t)
        return "";
      try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let formattedTime = moment.utc(t, "x").tz(tz);
        if (format == "fromnow")
          formattedTime = formattedTime.fromNow();
        else
          formattedTime = formattedTime.format(format);

        return formattedTime;
      } catch (e) {
        return "";
      } 
    },
    formatDate(t, format="MMMM Do YYYY, h:mm a") {
      if (!t)
        return "";
      try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const formattedTime = moment.utc(t, "x").tz(tz).format(format);
        return formattedTime;
      } catch (e) {
        return "";
      }
    },
    splitFilename(inFile) {
      try {
        return inFile.split("/")[inFile.split("/").length-1];
      } catch (err) {
        return "";
      }
    },
    prettyPhoneNumber(inPh) {
      if (!!inPh && inPh.length < 10)
        return inPh;
      let outPh;
      try {
        outPh = inPh.substring(2).replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, "($1) $2-$3");
      } catch (error) {
        outPh = inPh;
      }
      return outPh;
    },
    dialectLabel(code) {
      let languageLabel = code;
      try {
        languageLabel = this.dialects.find(o => o.code === code).label;
      } catch (error) {
        return code;
      }
      return languageLabel;
    },  
    bytesToSize(bytes) {
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0)
        return "0 Bytes";
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    formatNumber(num) {
      if (num) {
        if (num >= 1000000000000) {
          return (num / 1000000000000).toFixed(2).replace(/\.00$/, "") + "T";
        } else if (num >= 1000000000) {
          return (num / 1000000000).toFixed(2).replace(/\.00$/, "") + "B";
        } else if (num >= 1000000) {
          return (num / 1000000).toFixed(2).replace(/\.00$/, "") + "M";
        } else if (num >= 1000) {
          return (num / 1000).toFixed(2).replace(/\.00$/, "") + "K";
        } else {
          return num.toString();
        }
      } else {
        return 0;
      }
    },    
    timeDifference(timestamp) {
      if(timestamp) {
        timestamp = parseInt(timestamp);
        const now = new Date();
        const then = new Date(timestamp);
        const diff = Math.abs(now - then); // difference in milliseconds
    
        const seconds = Math.floor(diff / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
    
        if (days > 0) {
          const hoursInDay = hours % 24;
          const minutesInHour = minutes % 60;
          return `${days} day${days > 1 ? "s" : ""} ${hoursInDay} hour${hoursInDay !== 1 ? "s" : ""} ${minutesInHour} minute${minutesInHour !== 1 ? "s" : ""} ago`;
        } else if (hours > 0) {
          const minutesInHour = minutes % 60;
          return `${hours} hour${hours > 1 ? "s" : ""} ${minutesInHour} minute${minutesInHour !== 1 ? "s" : ""} ago`;
        } else if (minutes > 0) {
          const secondsInMinute = seconds % 60;
          return `${minutes} minute${minutes > 1 ? "s" : ""} ${secondsInMinute} second${secondsInMinute !== 1 ? "s" : ""} ago`;
        } else {
          return `${seconds} second${seconds !== 1 ? "s" : ""} ago`;
        }
      } else {
        return "";
      }
    },
    formatDuration(sec) {
      if (!sec) return "-";
    
      sec = parseInt(sec);

      const years = Math.floor(sec / (3600 * 24 * 365));
      const months = Math.floor((sec % (3600 * 24 * 365)) / (3600 * 24 * 30));
      const days = Math.floor((sec % (3600 * 24 * 30)) / (3600 * 24));
      const hours = Math.floor((sec % (3600 * 24)) / 3600);
      const minutes = Math.floor((sec % 3600) / 60);
      const seconds = Math.floor(sec % 60);

      let formattedDuration = "";
      if (years > 0) {
        return `${years}y ${months}m`;
      }

      if (!years && months > 0) {
        return `${months}m ${days}d`;
      }

      if (!years && !months) {
        if (days > 0) {
          if (sec > 0) {
            return `${days}d ${hours}h ${minutes}m ${seconds}s`;
          } else {
            return `${days}d ${hours}h ${minutes}m`;
          }
        } else {
          if (sec > 0) {
            if (hours > 0) {
              return `${hours}h ${minutes}m ${seconds}s`;
            } else {
              return `${minutes}m ${seconds}s`;
            }
          } else {
            return `${hours}h ${minutes}m`;
          }
        }
      }
      return formattedDuration;
    }
  }
};